/* eslint-disable react-hooks/exhaustive-deps */
import {useContext, useState} from 'react'
import {InquiresPageListingContext} from '../../context'
import Search from '../../../../components/Search'
import {defaultColumns, hasAccess} from '../../utils'
import {TableSettingsMenu} from '../../../../components/tableSettingsMenu'
import {useAppSelector} from '../../../../redux/useTypedSelector'
import Select from '../../../../components/Select/Select'

function InquiresPageListingHeader() {
  const {user} = useAppSelector((state) => state.auth)
  const [isOpen, setIsOpen] = useState(false)
  const {
    onSearch,
    Representatives,
    onChangeCustomerFilter,
    refetch,
    globalDefaultColumnsList,
    isLoadingGlobalDefaultColumnsList,
    refetchGlobalDefaultColumnsList,
    updateGlobalDefaultColumnsTableSorting,
    isLoadingGlobalDefaultColumnOperation,
    onChangeStatusFilter,
    filters,
    onResetFilters,
    hasFilterApplied,
    purchasers,
    isPurchasersLoading,
    onChangePurchaserFilter,
  } = useContext(InquiresPageListingContext)

  const accessPermissions = hasAccess(Representatives, user)

  return (
    <div className='d-flex mb-10 justify-content-between'>
      <Search
        onSearch={(searchTerm: string) => {
          onSearch(searchTerm)
        }}
      />
      <div className='d-flex align-items-center'>
        <div className='me-5 d-flex gap-5 align-items-center'>
          {filters?.status !== 'Archived' && (
            <Select
              id='status'
              label='Status'
              placeholder='Status: All'
              className='w-120px'
              isNullable={true}
              onChange={(e: any) => onChangeStatusFilter(e.target.value)}
              value={filters?.status}
              options={[
                {label: 'Open', value: 'Open'},
                {label: 'In Progress', value: 'In Progress'},
                {label: 'Pending', value: 'Pending'},
                {label: 'Done', value: 'Done'},
              ]}
            />
          )}
          <Select
            id='customer'
            label='Representative'
            className='w-200px'
            options={Representatives}
            value={filters?.rep_email}
            placeholder='All Representative'
            isNullable={true}
            defaultValue={accessPermissions?.repEmail || ''}
            onChange={(e: any) => onChangeCustomerFilter(e.target.value)}
            disabled={accessPermissions.repEmail}
          />
          <Select
            id='purchaser'
            label='Purchaser'
            className='w-200px'
            placeholder='All Purchaser'
            isNullable={true}
            onChange={(e: any) => onChangePurchaserFilter(e.target.value)}
            value={filters?.purchaser}
            options={purchasers}
            labelKey='name'
            valueKey='name'
            isLoading={isPurchasersLoading}
          />
          {hasFilterApplied && (
            <button className='btn btn-outline mt-7' onClick={onResetFilters}>
              Reset Filters
            </button>
          )}
        </div>
        <TableSettingsMenu
          id='kt_drawer_column_setting'
          defaultColumns={defaultColumns}
          permissionPath=''
          refetch={refetch}
          type={'product_inquiries'}
          globalDefaultColumnsList={globalDefaultColumnsList}
          isLoadingGlobalDefaultColumnsList={isLoadingGlobalDefaultColumnsList}
          refetchGlobalDefaultColumnsList={refetchGlobalDefaultColumnsList}
          updateGlobalDefaultColumnsTableSorting={updateGlobalDefaultColumnsTableSorting}
          isLoadingGlobalDefaultColumnOperation={isLoadingGlobalDefaultColumnOperation}
          isDrawerOpen={isOpen}
          closeDrawer={() => setIsOpen(false)}
          setIsDrawerOpen={setIsOpen}
        />
      </div>
    </div>
  )
}

export default InquiresPageListingHeader
